import { Slide } from "react-reveal";
import desktop from "../../../assets/images/case-studies/cases/arasus/arasus-desktop.jpg";
import tablet from "../../../assets/images/case-studies/cases/arasus/arasus-tablet.jpg";
import phone from "../../../assets/images/case-studies/cases/arasus/arasus-mobile.jpg";
import metrics from "../../../assets/images/case-studies/cases/arasus/arasus-metrics-after.jpg";
import KCGCaseStudyCard from "../case-study-cards/KCGCaseStudyCard";
import SdaCaseStudyCard from "../case-study-cards/SdaCaseStudyCard";
import FlexipaintersCaseStudyCard from "../case-study-cards/FlexipaintersCaseStudyCard";
import SolutionsNtunaCTAWorld from "../../solutions/SolutionsNtunaCTAWorld";

const ArasusCaseStudyBody = () => {
  return (
    <section>
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <ul className="case-study-body-items">
              <li className="case-study-item width-600 margin-auto section-spacing-50 no-padding-top">
                <Slide top>
                  <h3 className="case-study-body-section-title ntuna-text-fill">
                    Project Summary
                  </h3>
                </Slide>
                <div className="summary-container">
                  <div className="summary-item">
                    <p className="summary-name">Client</p>
                    <p className="summary-answer">Arasus Aviation</p>
                  </div>
                  <div className="summary-item">
                    <p className="summary-name">Industry</p>
                    <p className="summary-answer">Aviation & Tourism</p>
                  </div>
                  <div className="summary-item">
                    <p className="summary-name">Services</p>
                    <p className="summary-answer">
                      Website design, Payments integration, professional social
                      media accounts setup, digital marketing, management
                      system, CCTV Installation
                    </p>
                  </div>
                  <div className="summary-item">
                    <p className="summary-name">Location</p>
                    <p className="summary-answer">Uganda/International</p>
                  </div>
                  <div className="summary-item">
                    <p className="summary-name">Timeline</p>
                    <p className="summary-answer">6 Weeks</p>
                  </div>
                  <div className="summary-item">
                    <p className="summary-name">Website</p>
                    <p className="summary-answer">
                      <a
                        href="http://arasusug.web.app"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        www.arasusaviation.com
                      </a>
                    </p>
                  </div>
                </div>
              </li>
              <li className="case-study-item width-600 margin-auto section-spacing-50 no-padding-top">
                <Slide top>
                  <h3 className="case-study-body-section-title ntuna-text-fill">
                    Project Overview
                  </h3>
                </Slide>
                <div className="case-study-item-text font-inter-regular">
                  <p>
                    <a
                      href="http://ArasusAviation.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Arasus Aviation
                    </a>
                    , a new entrant into the Ugandan aviation and tourism
                    market, required a strong, credible, and fully integrated
                    digital and operational foundation to support their launch
                    and growth.
                  </p>
                  <p>
                    NTUNA.COM delivered a complete end-to-end solution—covering
                    website design and development, secure payment integration,
                    professional social media setup, digital marketing
                    campaigns, Google Workspace configuration, and CCTV
                    installation—to ensure both their online presence and
                    physical operations were efficient, secure, and scalable.
                  </p>
                  <p>
                    The goal was not just to build a website but to create a
                    seamless ecosystem that enables customer acquisition, secure
                    transactions, team collaboration, and operational security.
                  </p>
                  <p>
                    Beyond implementation, we equipped the Arasus team with the
                    knowledge needed to effectively manage their systems,
                    ensuring long-term independence and sustained performance.
                  </p>
                  <p>
                    This holistic approach positioned Arasus Aviation with the
                    credibility, visibility, and systems needed to compete and
                    scale effectively from day one.
                  </p>
                </div>
              </li>
              <li className="case-study-item width-800 margin-auto section-spacing-50 no-padding-top">
                <Slide top>
                  <h3 className="case-study-body-section-title ntuna-text-fill">
                    The Challenge
                  </h3>
                </Slide>
                <div className="case-study-item-text font-inter-regular">
                  <p>
                    As a new entrant into the Ugandan aviation and tourism
                    market, Arasus Aviation faced the critical challenge of
                    establishing credibility, visibility, and operational
                    efficiency from the ground up.
                  </p>

                  <ul className="case-challenge-list padding-16">
                    <li>
                      <h4>Existing Website Limitations</h4>
                      <p>
                        Arasus's existing digital presence was not aligned with
                        their ambitions. While they had a website in place, it
                        functioned more like a static brochure — lacking the
                        performance, structure, and conversion strategy needed
                        to attract, engage, and convert clients into bookings.
                      </p>
                    </li>
                    <li>
                      <h4>Payment Challenges</h4>
                      <p>
                        Beyond the website, they required a seamless and
                        reliable payment ecosystem to support both online
                        transactions (card and mobile money payments) and
                        in-field payments through POS machines for their local
                        and international clients' bookings payments.
                      </p>
                    </li>
                    <li>
                      <h4>Operational Gaps & Brand obscuity</h4>
                      <p>
                        Additionally, there was a need for efficient internal
                        communication tools, stronger brand visibility across
                        social media platforms, and secure operational
                        infrastructure.
                      </p>
                    </li>
                  </ul>
                </div>
              </li>
              <li className="case-study-item width-600 margin-auto section-spacing-50 no-padding-top">
                <Slide top>
                  <h3 className="case-study-body-section-title ntuna-text-fill">
                    The Solution
                  </h3>
                </Slide>
                <div className="case-study-item-text font-inter-regular">
                  <p>
                    To address Arasus Aviation's challenges, we delivered a
                    fully integrated digital and operational solution —
                    combining a high-performance web development, secure payment
                    systems integration, digital marketing and internal
                    infrastructure to support both customer experience,
                    operational security and business efficiency
                  </p>

                  <ul className="case-challenge-list padding-16">
                    <li>
                      <h4>
                        <span className="ntuna-coral">✔︎ </span> High performance
                        website design & development
                      </h4>
                      <p>
                        We redesigned and developed a fully custom,
                        high-performance responsive website — moving from a
                        static brochure to a conversion-focused platform.
                      </p>
                      <Slide top>
                        <div className="case-study-images-container section-spacing-24">
                          <figure>
                            <img
                              src={tablet}
                              alt="Arasus Aviation website tablet view"
                            />
                            <figcaption>
                              Arasus Aviation website tablet view
                            </figcaption>
                          </figure>
                          <figure>
                            <img
                              src={phone}
                              alt="Arasus Aviation website mobile phone view"
                            />
                            <figcaption>
                              Arasus Aviation website mobile phone view
                            </figcaption>
                          </figure>
                          <figure className="case-big-img">
                            <img
                              src={desktop}
                              alt="Arasus Aviation website desktop view"
                            />
                            <figcaption>
                              Arasus Aviation website desktop view
                            </figcaption>
                          </figure>
                        </div>
                      </Slide>

                      <p>
                        The new website was built to attract, engage and convert
                        visitors into bookings, with optimized performance and
                        clear user journeys.
                      </p>
                      <Slide top>
                        <div className="case-study-images-container section-spacing-24">
                          <figure className="case-big-img">
                            <img
                              src={metrics}
                              alt="Arasus Aviation new website performance metrics"
                              className="box-shadow"
                            />
                            <figcaption>
                              Arasus Aviation new website performance metrics
                            </figcaption>
                          </figure>
                        </div>
                      </Slide>
                    </li>
                    <li>
                      <h4>
                        <span className="ntuna-coral">✔︎ </span> Payment Systems
                        Integration
                      </h4>
                      <p>
                        We implemented a seamless payment ecosystem supporting
                        both online and in-field transactions. This included
                        secure card and mobile money payments setup, and POS
                        machines integration for on-ground client transactions.
                        It ensured flexibility and convinience for both local
                        and international clients.
                      </p>
                    </li>
                    <li>
                      <h4>
                        <span className="ntuna-coral">✔︎ </span>Social Media &
                        Digital Marketing
                      </h4>
                      <p>
                        We professionally setup Arasus Aviation's social media
                        accounts and targeted digital marketing campaigns to
                        increase brand visibility, attract new customers and
                        drive engagement across key channels.
                      </p>
                    </li>
                    <li>
                      <h4>
                        <span className="ntuna-coral">✔︎ </span>Company
                        Management System Setup
                      </h4>
                      <p>
                        We deployed a management system to enable secure,
                        professional business communications and seamless
                        collaboration for the Arasus team — allowing executives
                        to operate efficiently from anywhere.
                      </p>
                    </li>
                    <li>
                      <h4>
                        <span className="ntuna-coral">✔︎ </span>CCTV Installation
                        & Security
                      </h4>
                      <p>
                        We deployed a reliable CCTV system at the Arasus
                        Aviation premises and the residence of the executives to
                        enhance operational security, ensuring safety of
                        physical assets and supporting day-to-day monitoring of
                        business activities.
                      </p>
                    </li>
                    <li>
                      <h4>
                        <span className="ntuna-coral">✔︎ </span>Team Training &
                        Handover
                      </h4>
                      <p>
                        Beyond implementation, we provided a hands-on training
                        to equip the Arasus team with the knowledge and
                        confidence to manage their systems effectively —
                        ensuring long term independence and smooth day-to-day
                        operations.
                      </p>
                    </li>
                  </ul>
                </div>
              </li>
              <li className="case-study-item width-600 margin-auto section-spacing-50 no-padding-top">
                <Slide top>
                  <h3 className="case-study-body-section-title ntuna-text-fill">
                    What the Client Said
                  </h3>
                </Slide>
                <div className="case-study-item-text font-inter-regular">
                  <blockquote>
                    <p>
                      "What stood out with NTUNA.COM was their ability to
                      understand our vision and translate it into a fully
                      integrated solution. The systems they implemented — from
                      our new website to payments and internal operations — have
                      positioned us to operate efficiently and grow with
                      confidence."
                    </p>
                    <p className="boldTitle right-align">
                      — Mr. Emmad Swaleh, CEO, Arasus Aviation
                    </p>
                  </blockquote>
                </div>
              </li>
            </ul>
            <SolutionsNtunaCTAWorld />
            <ul>
              <li className="case-study-item section-spacing-50 no-padding-top">
                <Slide top>
                  <h3 className="case-study-body-section-title ntuna-text-fill">
                    Related Case Studies
                  </h3>
                </Slide>
                <ul className="case-studies-container">
                  <FlexipaintersCaseStudyCard />
                  <KCGCaseStudyCard />
                  <SdaCaseStudyCard />
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ArasusCaseStudyBody;
